import { render, staticRenderFns } from "./PageListBySubject.vue?vue&type=template&id=5ab68054&scoped=true"
import script from "./PageListBySubject.vue?vue&type=script&lang=ts"
export * from "./PageListBySubject.vue?vue&type=script&lang=ts"
import style0 from "./PageListBySubject.vue?vue&type=style&index=0&id=5ab68054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab68054",
  null
  
)

export default component.exports